import { client } from '@/services/api'

// Variante-A-Auftrag (Control Center, Option B): der Browser spricht
// control_server.py auf dem Mac DIREKT an (CONTROL_BASE, siehe
// useServerMonitor.js) - das Token dafür kommt von HIER
// (GET /api/control-center/token, rollengeprüft admin/portfolio_manager).
// Modul-weiter Singleton-State wie useDeploymentMode.js: das Token wird
// bis kurz vor Ablauf wiederverwendet statt bei jedem Control-Center-
// Request (Poll-Intervall 10s, Token-Gültigkeit 5 Minuten) neu geholt.
const REFRESH_MARGIN_SECONDS = 30

let cachedToken = null
let cachedExpiry = 0 // Unix-Timestamp (Sekunden)
let pendingFetch = null

// Generationszähler (Sicherheit): clearControlCenterToken() erhöht ihn.
// Ein Abruf, der VOR einem Logout/Login gestartet wurde, darf das Token
// danach nicht mehr in den Cache schreiben - sonst könnte ein noch
// laufender Request eines alten Admin-Tokens den Cache nach dem Logout
// wieder befüllen, obwohl im selben Tab längst ein anderer Nutzer
// angemeldet ist. Der ursprüngliche Aufrufer bekommt seinen Wert trotzdem
// zurück (er "verdient" ihn noch, er war ja beim Start berechtigt) - nur
// der SHARED CACHE wird nicht mehr davon befüllt.
let generation = 0

async function fetchToken(myGeneration) {
  const resp = await client.get('/api/control-center/token')
  if (myGeneration === generation) {
    cachedToken = resp.data.token
    cachedExpiry = resp.data.expires_at
  }
  return resp.data.token
}

// Wirft weiter (403 Reader/Analyst, 503 Secret nicht konfiguriert,
// Netzwerkfehler) - der Aufrufer entscheidet, welche Meldung das für die
// jeweilige UI bedeutet (siehe useServerMonitor.js).
export async function getControlCenterToken() {
  const now = Date.now() / 1000
  if (cachedToken && now < cachedExpiry - REFRESH_MARGIN_SECONDS) {
    return cachedToken
  }
  // Mehrere gleichzeitige Aufrufer (Poll-Intervall + manueller Refresh)
  // teilen sich denselben Fetch statt das Token doppelt zu holen.
  if (!pendingFetch) {
    const myGeneration = generation
    pendingFetch = fetchToken(myGeneration).finally(() => { pendingFetch = null })
  }
  return pendingFetch
}

// Sicherheit: modulweiter Cache überlebt sonst Logout/Login im selben Tab -
// ein nachfolgender Nutzer könnte ein noch gültiges Admin-Token weiter
// nutzen. Muss bei JEDER Authentifizierungs-Änderung aufgerufen werden
// (siehe auth.js login()/logout(), portalApi.js portalLogin()).
export function clearControlCenterToken() {
  generation += 1
  cachedToken = null
  cachedExpiry = 0
  // NICHT auf einen laufenden pendingFetch warten/ihn abbrechen - er darf
  // einfach auslaufen (sein Ergebnis landet dank des Generationschecks oben
  // nicht mehr im Cache). pendingFetch hier zurücksetzen, damit ein Aufruf
  // direkt nach clearControlCenterToken() nicht auf das alte (jetzt
  // irrelevante) Promise wartet, sondern sofort einen neuen, eigenen Fetch
  // mit der neuen Generation startet.
  pendingFetch = null
}

// Gemeinsamer Retry-Wrapper für useServerMonitor.js: bei 401 vom
// control_server (z.B. nach CONTROL_SERVER_SECRET-Rotation) Cache
// verwerfen und GENAU EINMAL mit frischem Token wiederholen, statt den
// Nutzer mit einem veralteten Secret dauerhaft auszusperren.
export async function withControlCenterToken(makeRequest) {
  const token = await getControlCenterToken()
  try {
    return await makeRequest(token)
  } catch (err) {
    if (err.response?.status === 401) {
      clearControlCenterToken()
      const freshToken = await getControlCenterToken()
      return await makeRequest(freshToken)
    }
    throw err
  }
}
